<template>
  <div>
    <el-form
      ref="form"
      :model="model"
      :rules="rules"
      :inline="inline"
      :label-position="labelPosition"
      :label-width="labelWidth"
      class="form"
    >
      <el-form-item
        v-for="(row, index) in rows"
        :key="index"
        :label="row.label || ` `"
        :prop="row.prop"
        :required="row.required"
        :style="{ width: row.width, padding: row ? '0 20px' : '' }"
        :class="row.itemCustomClass"
      >
        <el-input
          v-model.trim="modelData[getPropByPath(model, row.prop).k]"
          :disabled="row.disabled"
          :readonly="row.readonly"
          :placeholder="row.placeholder || ''"
          v-if="row.type == 'text'"
          :class="row.customClass"
        ></el-input>
        <el-input
          v-model.number="
            getPropByPath(model, row.prop).o[getPropByPath(model, row.prop).k]
          "
          :class="row.customClass"
          :disabled="row.disabled"
          :readonly="row.readonly"
          v-if="row.type == 'number'"
        ></el-input>
        <el-input
          v-model="
            getPropByPath(model, row.prop).o[getPropByPath(model, row.prop).k]
          "
          :class="row.customClass"
          :disabled="row.disabled"
          :readonly="row.readonly"
          type="textarea"
          v-if="row.type == 'textarea'"
        ></el-input>
        <el-select
          v-model="modelData[getPropByPath(model, row.prop).k]"
          :placeholder="row.placeholder"
          :disabled="row.disabled"
          :clearable="row.clearable"
          :filterable="row.filterable"
          :multiple="row.multiple"
          :allow-create="row.allowCreate"
          :class="row.customClass"
          v-if="row.type == 'select'"
          @change="value => handleAction('change', row.prop, value)"
        >
          <el-option
            v-for="option in row.options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
        <el-cascader
          v-if="row.type == 'cascader'"
          :options="row.options"
          :placeholder="row.placeholder"
          :show-all-levels="true"
          :class="row.customClass"
          :clearable="row.clearable"
          :change-on-select="row.changeOnSelect"
          v-model="modelData[getPropByPath(model, row.prop).k]"
        ></el-cascader>
        <el-radio-group
          v-if="row.type == 'radio'"
          v-model="modelData[getPropByPath(model, row.prop).k]"
        >
          <el-radio
            v-for="option in row.options"
            :key="option.value"
            :label="option.value"
            >{{ option.label }}</el-radio
          >
        </el-radio-group>
        <el-checkbox-group
          v-if="row.type == 'checkbox'"
          v-model="modelData[getPropByPath(model, row.prop).k]"
        >
          <el-checkbox
            v-for="option in row.options"
            :key="option.value"
            :label="option.value"
            >{{ option.label }}</el-checkbox
          >
        </el-checkbox-group>
        <el-date-picker
          v-if="row.type == 'datetime'"
          v-model="modelData[getPropByPath(model, row.prop).k]"
          type="datetime"
          :class="row.customClass"
          :placeholder="row.placeholder"
        ></el-date-picker>
        <el-date-picker
          v-if="row.type == 'daterange'"
          v-model="modelData[getPropByPath(model, row.prop).k]"
          type="daterange"
          :class="row.customClass"
          @change="value => handleAction('change', row.prop, value)"
          :placeholder="row.placeholder"
        ></el-date-picker>
        <template v-if="row.type == 'operation'">
          <el-button
            v-for="(btn, index) in row.btns"
            :type="btn.type"
            @click.enter="btnClick(btn.method)"
            :key="index"
            >{{ btn.label }}</el-button
          >
        </template>
        <Cell
          v-if="row.render"
          :row="row"
          :index="index"
          :render="row.render"
          :class="row.customClass"
        ></Cell>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Cell from "./expand";

export default {
  data() {
    return {
      modelData: {}
    };
  },
  components: {
    Cell
  },
  props: {
    model: {
      type: Object,
      default() {
        return {};
      }
    },
    rows: {
      type: Array,
      default() {
        return [];
      }
    },
    rules: {
      type: Object,
      default() {
        return {};
      }
    },
    inline: {
      type: Boolean,
      default() {
        return false;
      }
    },
    labelPosition: {
      type: String,
      default: "right"
    },
    labelWidth: {
      type: String,
      default: "200px"
    }
  },
  methods: {
    getPropByPath(obj, path) {
      let tempObj = obj;
      path = path.replace(/\[(\w+)\]/g, ".$1");
      path = path.replace(/^\./, "");

      let keyArr = path.split(".");
      let i = 0;

      for (let len = keyArr.length; i < len - 1; ++i) {
        let key = keyArr[i];
        if (key in tempObj) {
          tempObj = tempObj[key];
        } else {
          throw new Error("please transfer a valid prop path to form item!");
        }
      }
      return {
        o: tempObj,
        k: keyArr[i],
        v: tempObj[keyArr[i]]
      };
    },
    handleAction(event, prop, value) {
      let e = {
        event: event,
        prop: prop,
        value: value
      };
      this.$emit("onAction", e);
    },
    btnClick(method) {
      this[method] && this[method]();
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit("submit");
        }
      });
    },
    reset() {
      this.$emit("reset");
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  created() {
    // 初始化
    this.modelData = this.model;
  }
};
</script>
